import { defineMessages } from "react-intl";

const PREFIX = "User.UserSettings";
export default defineMessages({
  settings: {
    id: `${PREFIX}.settings`,
    defaultMessage: "Settings",
  },
  password: {
    id: `${PREFIX}.password`,
    defaultMessage: "Password",
  },
  newPassword: {
    id: `${PREFIX}.newPassword`,
    defaultMessage: "New Password",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },
  confirmPasswordNoEqualError: {
    id: `${PREFIX}.confirmPasswordNoEqualError`,
    defaultMessage: "Password mismatch",
  },
  success: {
    id: `${PREFIX}.success`,
    defaultMessage: "Password successfully changed",
  },
  passwordWrongError: {
    id: `${PREFIX}.passwordWrongError`,
    defaultMessage: "Current password was entered incorrectly",
  }
});
